import { cerApi } from 'yxt-biz-pc/packages/api';

// 获取模板证书
export const getCer = (id) => {
  return cerApi.get(`/cer/${id}`);
};
